import React from 'react';
import { selectNotificationsEnabled } from 'store/Faraday/selectors';
import { selectIsLoggedIn } from 'store/Sesion/selectors';
import { selectLocation } from 'store/Router/selectors';
import { useSelector } from 'react-redux';
import Searcher from 'Common/Components/Searcher';
import WorkspaceSelector from './WorkspaceMenuSelector';
import { EEFeatureSlot } from 'Common/ee/EEFeatureSlot';
import ThemeToggle from './ThemeToggle';
import ProcessingQueueButton from './ProcessingQueueButton';
import {
  Header, Separator, LeftZone, CenterZone, RightZone
} from './styled';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_VULNS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import VulnsCounter from './VulnsCounter';
import AssetSelector from './AssetSelector';
import Title from './Title';
import HomeButton from './HomeButton';
import HostModalCreate from '../HostModalCreate';

const NavMenuContext = () => {
  const loggedIn = useSelector((state) => selectIsLoggedIn(state));
  const location = useSelector((state) => selectLocation(state));
  const notificationsEnabled = useSelector((state) => selectNotificationsEnabled(state));
  const showProcessingQueueButton = useSelector((state) => selectAllowedByRole(state, FEATURE_VULNS, PERMISSION_TYPES.CREATE));
  const isInsideWs = location.pathname.startsWith('/feed') ||
   location.pathname.startsWith('/host/') ||
   location.pathname.startsWith('/manage') ||
   location.pathname.startsWith('/vulns/') ||
   location.pathname.startsWith('/service/') ||
   location.pathname.startsWith('/credentials');
  const customStyle = location.pathname.startsWith('/analytics') ||
    location.pathname.startsWith('/notifications-log');

  const customPadding = location.pathname === '/automation/agents' ||
    location.pathname.startsWith('/analytics') ||
    location.pathname.startsWith('/notifications-log');

  return loggedIn && (
    <Header customPadding={ customPadding } customStyle={ customStyle }>
      <LeftZone>
        <Title />
        { isInsideWs &&
          <>
            <HomeButton />
            <Separator />
            <WorkspaceSelector />
          </>
        }
        <AssetSelector />
        <VulnsCounter />
      </LeftZone>
      <CenterZone>
        <Searcher />
      </CenterZone>
      <HostModalCreate />
      <RightZone>
        <ThemeToggle />
        { showProcessingQueueButton && <ProcessingQueueButton /> }
        { notificationsEnabled && <EEFeatureSlot featureKey="navmenu-notifications-dropdown" /> }
      </RightZone>
    </Header>
  );
};

export default NavMenuContext;
